export default __webpack_public_path__ + "static/media/FurtherDevelopment.74b9483c.svg";